<mat-error *ngIf="!!selectionFormControl"
           [style.visibility]="selectionFormControl.value.length ? 'hidden' : 'visible'"
           class="grid-error"
           translate>
    trigger_required_robots_not_selected
</mat-error>

<ui-grid [data]="data$ | async"
         [multiPageSelect]="true"
         [virtualScroll]="virtualScroll"
         [loading]="loading$ | async"
         class="ui-process-robots-grid"
         data-cy="process-robots-grid">
    <ui-grid-header [search]="true">
    </ui-grid-header>
    <ui-grid-column *ngIf="isJobsGrid"
                    [visible]="false"
                    [title]="'robots_grid_status' | translate"
                    [resizeable]="false"
                    property="state">
        <ui-grid-dropdown-filter [items]="stateList"></ui-grid-dropdown-filter>
    </ui-grid-column>
    <ui-grid-column [sortable]="true"
                    [searchable]="true"
                    [title]="'job_modal_grid_robot' | translate"
                    [resizeable]="false"
                    width="40%"
                    property="robot.name">
        <ng-template let-entry="data">
            <mat-icon *ngIf="entry.state === 'Disconnected'; else notDisconnected"
                      svgIcon="uipath:StatusCanceling"></mat-icon>
            <ng-template #notDisconnected>
                <mat-icon *ngIf="entry.isUnresponsive; else responding"
                          svgIcon="uipath:StatusWarning"></mat-icon>
                <ng-template #responding>
                    <mat-icon *ngIf="entry.state === 'Busy'; else statusOK"
                              svgIcon="uipath:StatusPlay"></mat-icon>
                    <ng-template #statusOK>
                        <mat-icon svgIcon="uipath:StatusOK"
                                  color="success"></mat-icon>
                    </ng-template>
                </ng-template>
            </ng-template>
            <span [matTooltip]="entry.robot.name">
                {{ entry.robot.name }}
            </span>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [sortable]="true"
                    [searchable]="true"
                    [title]="'job_modal_grid_machine' | translate"
                    [resizeable]="false"
                    [width]="isJobsGrid ? '40%' : '60%' "
                    property="hostMachineName">
        <ng-template let-entry="data">
            <ng-container *ngLet=" entry.licenseErrorCode !== LicenseErrorCode[LicenseErrorCode.RuntimeDisabled] ?
                                        entry.hostMachineName :
                                        ('machine_is_disabled' | translate: {
                                            machine: entry.hostMachineName,
                                            licenseType: entry.robot.type
                                    }) as typeTooltip">
                <span [class.strikethrough]="entry.licenseErrorCode === LicenseErrorCode[LicenseErrorCode.RuntimeDisabled]"
                      [matTooltip]="typeTooltip">
                    {{ entry.hostMachineName }}
                    <ng-container *ngIf="entry.robot.hostingType === RobotHostingType.Floating &&
                                entry.machineName">
                        ({{ entry.machineName }})
                    </ng-container>
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [primary]="true"
                    [sortable]="true"
                    [title]="'robots_grid_status' | translate"
                    [resizeable]="false"
                    [visible]="isJobsGrid"
                    property="state"
                    width="20%"
                    sort="asc">
        <ng-template let-entry="data">
            <ng-container *ngLet="('RobotState_' + entry.computedState | translate) as stateText">
                <div [matTooltip]="stateText">
                    {{ stateText }}
                </div>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
